import React, { Component } from "react";
import { observer } from "mobx-react";
import { Form, Input, Message, Checkbox } from "semantic-ui-react";
import "~/styles/tourbuzz/Header.less";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import ModalUnsavedConfirmation from "~/components/element/ModalUnsavedConfirmation";
import PageStore from "~/stores/PageStore";
import FormEditor from "./FormEditor";
import ImageUpload from "~/components/element/ImageUpload/ImageUpload";

@observer
class PageForm extends Component {
  setPhotoData(encoded) {
    const { pageStore } = this.props;
    const { page } = pageStore;
    page.photoData = encoded;
  }

  checkPhoto(e, data) {
    const { pageStore } = this.props;
    const { page } = pageStore;
    if (data.checked === true) {
      page.photoUrl = null;
    }
  }

  render() {
    const { onChange, onChangeCheckbox, onChangeSlug, onSave, pageStore, t } = this.props;
    const { page, errorMessages } = pageStore;

    const pagePhotoUrl =
      page.photoUrl !== null
        ? page.photoPathWeb
        : "https://www.urbanimmersive.com/images/masthead/tourbuzz/bg_banner_6.jpg";

    return (
      <>
        <ModalUnsavedConfirmation when={pageStore.hasUnsavedData} onSave={() => onSave()} />
        <Form>
          <h4 style={{ marginTop: "3rem" }}>{t("customerPortal:title")}</h4>
          <Input
            fluid
            name="title"
            onChange={e => onChange(e)}
            placeholder={t("customerPortal:makeTitle")}
            defaultValue={page.isToursPage ? t("customerPortal:myTours") : page.title}
            disabled={page.isToursPage}
          />
          {errorMessages && errorMessages.title ? <Message negative>{errorMessages.title}</Message> : null}

          <h4>{t("customerPortal:path")}</h4>
          <Input
            label={`customer-portal/${page.customerId}/`}
            fluid
            name="slug"
            onChange={e => onChangeSlug(e)}
            value={page.isToursPage ? "tours" : page.slug}
            placeholder={t("customerPortal:makePath")}
            disabled={page.isToursPage}
          />
          {errorMessages && errorMessages.slug ? <Message negative>{errorMessages.slug}</Message> : null}

          <h4>{t("customerPortal:pagePhoto")}</h4>
          {page.photoUrl !== null ? (
            <Form.Checkbox
              className="page-img-delete"
              label={t("clientPanelInfo:clickDelete")}
              onChange={(event, data) => this.checkPhoto(event, data)}
            />
          ) : (
            <p>{t("customerPortal:clickToAddPhotoToYourPage")}</p>
          )}
          <div className="page-photo-img-wrap">
            <ImageUpload onFileSelected={encoded => this.setPhotoData(encoded)} defaultSrc={pagePhotoUrl} />
          </div>

          {!page.isToursPage && (
            <>
              <h4>{t("customerPortal:status")}</h4>

              {/* eslint-disable-next-line react/no-unescaped-entities */}
              <span style={{ marginBottom: "2px" }}>{t("customerPortal:checkStatus")}</span>
              <Checkbox
                style={{ marginLeft: "1em", marginBottom: "-0.4em" }}
                fitted
                toggle
                checked={page.isActive}
                onChange={(e, data) => onChangeCheckbox(e, data)}
              />
              {errorMessages && errorMessages.isActive ? <Message negative>{errorMessages.isActive}</Message> : null}
            </>
          )}

          {!page.isToursPage && (
            <>
              <h4>{t("customerPortal:content")}</h4>
              <FormEditor
                label=""
                dataStore={pageStore}
                name="page.description"
                config={{
                  placeholder: t("startWriting"),
                  height: "600px",
                }}
              />
              {errorMessages && errorMessages.description ? (
                <Message negative>{errorMessages.description}</Message>
              ) : null}
            </>
          )}
        </Form>
      </>
    );
  }
}
PageForm.propTypes = {
  onChange: PropTypes.func.isRequired,
  onChangeCheckbox: PropTypes.func.isRequired,
  onChangeSlug: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  pageStore: PropTypes.instanceOf(PageStore),
  t: PropTypes.func.isRequired,
};

export default withTranslation()(PageForm);
